import { render } from "./list.vue?vue&type=template&id=c427baae"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=c427baae&lang=less"

import exportComponent from "/Users/zhanghui/Documents/workSpace/github/coco-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__